import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { ComplexModalTemplate } from '@connect-services/client/components/complexe-modal/complex-modal-template.component';
import { SynopticPlanItem } from '@connect-services/client/components/synoptic/synoptic-plan/plan-core/synoptic-plan.models';
import { ModalResultEnum } from '@connect-services/client/models/common.model';
import { PositionValue, SynopticPositionListValues } from '@connect-services/client/sdk/api';
import { SelectComponent, SelectOption } from '@connect-services/src/lib/components/select/select.component';
import { RessourcesModule } from '@ressources/client/ressources.module';

type PositionForm = {
    assignment: FormControl<string | null>;
    engineeringType: FormControl<string | null>;
    function: FormControl<string | null>;
};

export type PositionEditModalResult = {
    assignment: string | null;
    engineeringType: string | null;
    function: string | null;
};
export type PositionEditModalData = { fiber?: SynopticPlanItem; positionListValues: SynopticPositionListValues };

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [ComplexModalTemplate, RessourcesModule, SelectComponent],
    selector: 'app-position-edit-modal',
    templateUrl: './position-edit-modal.component.html',
})
export class PositionEditModalComponent implements OnInit {
    public data: PositionEditModalData = inject(MAT_DIALOG_DATA);

    protected assignmentOptions: SelectOption<string>[] = [];
    protected engineeringTypes: SelectOption<string>[] = [];
    protected functionTypes: SelectOption<string>[] = [];
    protected positionForm!: FormGroup<PositionForm>;

    private dialogRef = inject(MatDialogRef);

    public ngOnInit(): void {
        this.positionForm = this.getForm(this.data.fiber);
        this.assignmentOptions = this.data.positionListValues.assignments.map((value: PositionValue) => ({
            label: value.libelle,
            value: value.code,
        }));
        this.engineeringTypes = this.data.positionListValues.engineeringTypes.map((value: PositionValue) => ({
            label: value.libelle,
            value: value.libelle,
        }));
        this.functionTypes = this.data.positionListValues.functions.map((value: PositionValue) => ({
            label: value.libelle,
            value: value.code,
        }));
    }

    protected submit(result: ModalResultEnum): void {
        if ([ModalResultEnum.CANCEL, ModalResultEnum.CLOSE].includes(result)) {
            return this.dialogRef.close();
        }

        if (this.positionForm.invalid) {
            return;
        }

        return this.dialogRef.close(this.positionForm.getRawValue());
    }

    private getForm(fiber?: SynopticPlanItem): FormGroup<PositionForm> {
        return new FormGroup<PositionForm>({
            assignment: new FormControl<string | null>(fiber?.affectation ?? null),
            engineeringType: new FormControl<string | null>(fiber?.type_ingenierie ?? null),
            function: new FormControl<string | null>(fiber?.connectorisation ?? null),
        });
    }
}
